module.exports = __webpack_public_path__ + "img/credit-card-search.9abb1e5e.svg";